module.exports = __webpack_public_path__ + "static/media/onlinebibliotheek-min.75faa842.png";